import { render } from "./ServiceMain.vue?vue&type=template&id=c5ccb012&scoped=true"
import script from "./ServiceMain.vue?vue&type=script&lang=js"
export * from "./ServiceMain.vue?vue&type=script&lang=js"

import "./ServiceMain.vue?vue&type=style&index=0&id=c5ccb012&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5ccb012"]])

export default __exports__